<template>
  <div class="">
    <div class="section-box">
      <div class="das-form-container">
        <div class="das-form-group">
          <span>{{ datetimeDisplay }}</span>
          <InfoList
            style="padding-top: 10px"
            class="das-form-container"
            :columns="1"
          >
            <InfoListLabel>
              <div class="label">Thu ngân</div>
            </InfoListLabel>
            <InfoListInput class="das-form-input">
              <div>
                {{ workShiftInfo?.username }}
              </div>
            </InfoListInput>

            <InfoListLabel>
              <div class="label">Quầy</div>
            </InfoListLabel>
            <InfoListInput class="das-form-input">
              <div>{{ workShiftInfo?.ticket_office_name }}</div>
            </InfoListInput>
          </InfoList>
        </div>
      </div>
    </div>

    <div v-loading="loading" class="mt-10" style="height: 400px">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :context="context"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import RightPanel from '@/components/RightPanel'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { component as VueNumber } from '@coders-tm/vue-number-format'

import { getAllHotel } from '@/api/hotel'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import {
  getHistoryBreakfast,
  setHistoryBreakfast
} from '@/api/business_area_service/breakfastReal'
import { uploadAdjustRecord } from '@/api/cashier_service/closeShiftWork.js'
import CellRendererNumberDisplay from '@/views/mci/closeShiftWork/components/cellRendererNumberDisplay.vue'
import CellRenderCurrencyInput from '@/views/mci/closeShiftWork/components/CellRenderCurrencyInput.vue'
import CellRenderTextInput from '@/views/mci/closeShiftWork/components/CellRenderTextInput.vue'
import CellRenderDeleteIcon from '@/views/mci/closeShiftWork/components/CellRenderDeleteIcon.vue'
import Vue from 'vue'

export default {
  components: {
    Breadcrumb,
    RightPanel,
    SelectWithSearchTable,
    VueNumber,
    CalendarSelect,
    CellRenderTextInput: CellRenderTextInput,
    CellRenderDeleteIcon: CellRenderDeleteIcon,
    // CellRenderNoteInput,
    CellRendererNumberDisplay: CellRendererNumberDisplay,
    CellRenderCurrencyInput: CellRenderCurrencyInput
  },
  props: {
    workShiftInfo: {
      type: Object
    }
  },
  data() {
    return {
      cashListReportDialog: false,
      loading: false,
      listAssign: [],

      // workShiftInfo: null,
      datetime: this.$moment(),

      context: null,
      columns: [
        {
          headerName: 'STT',
          field: 'no',
          maxWidth: 80
        },
        {
          headerName: 'Recode',
          field: 'invoice_code',
          cellDataType: false,
          cellRendererSelector: params => {
            return {
              component: 'CellRenderTextInput',
              params: {
                colName: params.column.colId,
                align: 'align-left',
                max: 13
              }
            }
          }
        },
        {
          headerName: 'Hình thức thanh toán',
          children: [
            {
              headerName: 'Trước điều chỉnh',
              field: 'payment_before',
              cellDataType: false,
              // cellRenderer: CellRenderTextInput,
              cellRendererSelector: params => {
                return {
                  component: 'CellRenderTextInput',
                  params: {
                    colName: params.column.colId,
                    align: 'align-left',
                    max: 100
                  }
                }
              }
            },
            {
              headerName: 'Sau điều chỉnh',
              field: 'payment_after',
              cellDataType: false,
              // cellRenderer: CellRenderTextInput,
              cellRendererSelector: params => {
                return {
                  component: 'CellRenderTextInput',
                  params: {
                    colName: params.column.colId,
                    align: 'align-left',
                    max: 100
                  }
                }
              }
            }
          ]
        },
        {
          headerName: 'Thông tin cần điều chỉnh',
          children: [
            {
              headerName: 'Trước điều chỉnh',
              field: 'infor_before',
              cellDataType: false,
              // cellRenderer: CellRenderTextInput,
              cellRendererSelector: params => {
                return {
                  component: 'CellRenderTextInput',
                  params: {
                    colName: params.column.colId,
                    align: 'align-left',
                    max: 100
                  }
                }
              }
            },
            {
              headerName: 'Sau điều chỉnh',
              field: 'infor_after',
              cellDataType: false,
              // cellRenderer: CellRenderTextInput,
              cellRendererSelector: params => {
                return {
                  component: 'CellRenderTextInput',
                  params: {
                    colName: params.column.colId,
                    align: 'align-left',
                    max: 100
                  }
                }
              }
            }
          ]
        },
        {
          headerName: '',
          field: 'delete',
          cellRenderer: 'CellRenderDeleteIcon',
          cellClass: 'grid-cell-centered',
          cellRendererParams: params => {
            return {
              colName: params.column.colId
            }
          },
          maxWidth: 100
        }
      ],
      rows: [
        {
          no: 1,
          invoice_code: '',
          payment_before: null,
          payment_after: '',
          infor_before: '',
          infor_after: ''
        }
      ],
      pinnedBottomRow: [
        {
          no: null,
          denomination: 'Tổng cộng',
          quantity: 0,
          total: 0,
          note: ''
        }
      ]
    }
  },
  computed: {
    datetimeDisplay() {
      return `Ngày ${this.datetime.date()} tháng ${
        this.datetime.month() + 1
      } năm ${this.datetime.year()}, ${this.datetime.hour()} giờ ${this.datetime.minute()} phút`
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {},
  methods: {
    updateCurrentDatetime() {
      this.datetime = this.$moment()
    },
    onResetSearchParams() {
      this.searchParams.date = this.$moment(new Date()).format('YYYY-MM-DD')
    },

    onAddRow() {
      const length = this.rows.length
      this.rows.push({
        no: length + 1,
        invoice_code: '',
        payment_before: null,
        payment_after: '',
        infor_before: '',
        infor_after: ''
      })
      this.rows = JSON.parse(JSON.stringify(this.rows))
    },

    changeCurrencyInput(params, value, colNm) {
      console.log(params, value, colNm)
      const rowIdx = params.rowIndex
      this.row[rowIdx][colNm] = value
    },

    textInputChange(params, value, colName) {
      const rowIdx = params.rowIndex
      this.rows[rowIdx][colName] = value
    },
    onDeleteIconClicked(params) {
      console.log('delete icon clicked', params)
      let tempRows = this.rows.filter(item => item.no !== params.data.no)
      tempRows = tempRows.map((item, index) => {
        return {
          ...item,
          no: index + 1
        }
      })
      this.rows = tempRows
    },
    async onConfirm() {
      console.log(this.rows)
      const rowsRemoveEmpty = this.rows.filter(item => {
        if (
          (item.invoice_code !== null && item.invoice_code !== '') ||
          (item.payment_before !== null && item.payment_before !== '') ||
          (item.payment_after !== null && item.payment_after !== '') ||
          (item.infor_before !== null && item.infor_before !== '') ||
          (item.infor_after !== null && item.infor_after !== '')
        )
          return item
      })
      console.log(rowsRemoveEmpty)
      for (var i = 0; i < rowsRemoveEmpty.length; i++) {
        if (
          rowsRemoveEmpty[i].invoice_code === null ||
          rowsRemoveEmpty[i].invoice_code === '' ||
          ((rowsRemoveEmpty[i].payment_before === null ||
            rowsRemoveEmpty[i].payment_before === '' ||
            rowsRemoveEmpty[i].payment_after === null ||
            rowsRemoveEmpty[i].payment_after === '') &&
            (rowsRemoveEmpty[i].infor_before === null ||
              rowsRemoveEmpty[i].infor_before === '' ||
              rowsRemoveEmpty[i].infor_after === null ||
              rowsRemoveEmpty[i].infor_after === ''))
        ) {
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.checkAgain`)
          })
          return false
        }
      }
      if (rowsRemoveEmpty?.length === 0) {
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.checkAgain`)
        })
        return false
      }
      console.log('pass validate')
      const payload = {
        adjusted_record_units: rowsRemoveEmpty,
        ticket_close_shift_id: this.workShiftInfo.id,
        create_time: this.datetime.format('YYYY-MM-DD HH:mm:ss')
      }
      await uploadAdjustRecord(payload)
        .then(res => {
          console.log(res.data)
          this.$emit('updateAdjustInfo', res.data)
          this.$message({
            type: 'success',
            message: this.$t('successMsg.updateSuccess')
          })
          this.$emit('updateAdjustReport', res.data.name + '.pdf')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.button-containers {
  position: fixed;
  bottom: 30px;
  right: 20px;
}
.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
